<template>
  <section>
    <b-row>
      <b-col lg="4" cols="12">
        <b-card>
          <b-card-text>
            <p class="text-uppercase custom-text-disabled">
              Recurring Details
            </p>
            <b-list-group flush>
              <b-list-group-item
              ><div class="text-base">
                Title:
                <span class="text-body-2 font-weight-bold">{{
                    policyDetails?.title
                  }}</span>
              </div></b-list-group-item>

              <b-list-group-item
              ><div class="text-base font-weight-semibold">
                Type:
                <span class="text-body-2 font-weight-bold">
                      <b-badge class="ml-1" variant="light-success">
                        {{ (policyDetails?.type)?.toUpperCase() }}
                      </b-badge>
                    </span>
              </div></b-list-group-item
              >

              <b-list-group-item
              ><div class="text-base font-weight-semibold">
                Duration (in days):
                <span class="text-body-2 font-weight-bold">
                      {{ policyDetails?.duration_in_days }}
                    </span>
              </div></b-list-group-item
              >

            </b-list-group>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col lg="8" cols="12">
        <b-card>
          <div>
            <div
                class="custom-search d-flex align-items-center justify-content-end"
            >
              <div
                  class="d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
              >
                <b-form-input
                    v-on:keyup="onSearch"
                    v-model.lazy="searchTerm"
                    placeholder="Search..."
                    type="text"
                    class="d-inline-block mr-sm-1 mb-1 mb-sm-0"
                />

                <template
                    v-if="$permissionAbility(PAYROLL_POLICY_ASSIGN, permissions)"
                >
                  <b-button
                      class="flex-shrink-0"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      v-on:click="showPolicyAssignModal"
                  >
                    Add Member
                  </b-button>
                </template>
              </div>
            </div>

            <vue-good-table
                styleClass="vgt-table table-custom-style striped"
                :line-numbers="false"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                :totalRows="totalRecords"
                :isLoading.sync="isLoading"
                :rows="rows"
                :sort-options="{
                enabled: true,
                multipleColumns: true,
                initialSortBy: [{ field: 'created_at', type: 'desc' }],
              }"
                :columns="columns"
                :pagination-options="{
                enabled: true,
                perPage: pageLength,
              }"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'format_user_info'">
                  <UserCard :user="props?.row?.user?.data" />
                </span>

                <span v-if="props.column.field === 'action'">
                  <span>
                    <div class="cursor-pointer" @click="onShow(props.row)">
                      <feather-icon
                        icon="Edit2Icon"
                          class="mr-50"
                      />
                    </div>
                </span>
                </span>

                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>

              <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Showing 1 to </span>
                    <b-form-select
                        v-model="pageLength"
                        :options="['10', '25', '50', '100', '500']"
                        class="mx-1"
                        @input="
                        (value) =>
                          props.perPageChanged({ currentPerPage: value })
                      "
                    />
                    <span class="text-nowrap">
                      of {{ props.total }} entries
                    </span>
                  </div>
                  <div>
                    <b-pagination
                        :value="1"
                        :total-rows="props.total"
                        :per-page="pageLength"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="mt-1 mb-0"
                        @input="
                        (value) => props.pageChanged({ currentPage: value })
                      "
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
        id="modal-policy-assign-user"
        centered
        title="Add Member To Policy"
        hide-footer
        @hidden="hiddenPolicyAssignModal"
        no-close-on-backdrop
    >
      <validation-observer ref="assignUserPolicy">
        <b-form v-on:submit.prevent="assignUserPolicyForm">
          <UserAssignPolicyForm
              :salaryType="'monthly'"
              @userAssignFromDataEvent="handleUserAssignFromData"
          />

          <b-form-group
              label="Start Date"
              label-for="start_date"
              class="required-label"
          >
            <ValidationProvider
                v-slot="{ errors }"
                name="start date"
                vid="start_date"
                rules="required"
            >
              <flat-pickr
                  id="start_date"
                  v-model="start_date"
                  class="form-control"
                  placeholder="Select Date"
                  :state="errors.length > 0 ? false : null"
                  :config="datePickerConfig"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </b-form-group>


          <template v-if="isUserPolicyAssignFormSubmitLoading">
            <b-button class="float-right" variant="primary" disabled>
              <b-spinner small />
              Loading...
            </b-button>
          </template>

          <template v-else>
            <b-button
                type="submit"
                class="float-right"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
            >
              Assign
            </b-button>
          </template>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-recurring-policy-assign-form"
        centered
        :title="'Update User Assign'"
        hide-footer
        no-close-on-backdrop
        @hidden="hiddenModal"
    >

      <validation-observer ref="policyForm">
        <b-form @submit.prevent="submit">


          <b-form-group
              label="Next Payslip Generate Date"
              label-for="next_date"
              class="required-label"
          >
            <ValidationProvider
                v-slot="{ errors }"
                name="next generate date"
                vid="next_date"
                rules="required"
            >
              <flat-pickr
                  id="dob"
                  v-model="next_generated_date"
                  class="form-control"
                  placeholder="Select Date"
                  :state="errors.length > 0 ? false : null"
                  :config="datePickerConfig"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </b-form-group>

          <!-- loading button -->
          <template v-if="isLoading">
            <b-button
                class="float-right"
                variant="primary"
                disabled
            >
              <b-spinner small />
              Loading...
            </b-button>
          </template>

          <!-- submit button -->
          <template v-else>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                class="float-right"
                variant="primary"
            >
              Submit
            </b-button>
          </template>
        </b-form>
      </validation-observer>
    </b-modal>
  </section>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BModal,
  BCol,
  BRow,
  BCardText,
  BSpinner,
  BTable,
  BListGroupItem,
  BListGroup,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, max } from "@core/utils/validations/validations";
import { salaryTypeConstants } from "@/helpers/constant/salaryTypeConstant";
import { amountValueTypeConstants } from "@/helpers/constant/amountValueTypeConstant";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";
import { PAYROLL_POLICY_ASSIGN } from "@/helpers/permissionsConstant";
import UserAssignPolicyForm from "@/views/admin/payroll-management/UserAssignPolicyForm.vue";
import UserCard from "@/layouts/components/UserCard.vue";
import FormatCurrency from "@/layouts/components/FormatCurrency.vue";
import flatPickr from 'vue-flatpickr-component'

export default {
  name: "PayrollPolicyAssignUserDetails",
  components: {
    FormatCurrency,
    BListGroup,
    BListGroupItem,
    UserCard,
    BTable,
    UserAssignPolicyForm,
    BForm,
    BButton,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BCol,
    BRow,
    BCardText,
    BSpinner,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      PAYROLL_POLICY_ASSIGN,

      defaultCurrency: "",
      selectUserId: "",
      usersOption: [],

      datePickerConfig: { static: true },

      policyId: "",
      policyDetails: "",
      start_date: "",
      next_generated_date: "",
      incomeTaxSlabs: "",
      policyAssignData: "",
      salaryTypeConstants,
      amountValueTypeConstants,
      pageLength: 10,
      tableFields: [
        { key: "#", label: "#" },
        { key: "starting_amount", label: "Starting Amount" },
        { key: "ending_amount", label: "Ending Amount" },
        { key: "rate", label: "Rate (%)" },
      ],

      columns: [
        {
          label: "User",
          field: "format_user_info",
        },

        {
          label: "Last Payslip Generated Date",
          field: "last_generated_date",
          formatFn: this.formatDate,
        },
        {
          label: "Next Payslip Generate Date",
          field: "next_generated_date",
          formatFn: this.formatDate,
        },

        {
          label: "Action",
          field: "action",
        },

      ],
      rows: [],
      searchTerm: "",
      delayTimer: null,
      isLoading: false,
      isUserPolicyAssignFormSubmitLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [{ field: "created_at", type: "desc" }],
        page: 1,
        perPage: 10,
      },
      department: {},
    };
  },
  computed: {
    ...mapGetters({
      permissions: "userModule/getPermissions",
    }),
    statusVariant() {
      const statusColor = {
        true: "light-success",
        false: "light-danger",
      };

      return (status) => statusColor[status];
    },
  },

  watch: {
    selectUserId(newData, oldData) {
      if (newData) {
        const departmentOption = this.usersOption.find(
            (item) => item.id == newData
        ).department;

        if (departmentOption) {
          this.$swal({
            title: "Warning!",
            text: "Your selected user has a department do you want to change department?",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Ok",
            showLoaderOnConfirm: true,
          }).then((result) => {
            if (result.isDismissed) {
              this.resetModal();
            }
          });
        }
      }
    },
  },

  async created() {
    try {
      const [getSetting, getCurrencies] = await Promise.all([
        this.getSetting({
          select: "currency_id",
        }),
        this.getCurrencies(),
      ]);

      // getSetting
      const currencyId = getSetting?.data?.data?.currency_id;

      // getCurrencies
      const currencyData = getCurrencies?.data?.data?.filter((item) => {
        return item?.id === currencyId;
      });

      this.defaultCurrency = currencyData?.[0]?.currency;
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }
  },

  methods: {

    async onShow(value) {
      this.policyId = value?.id

      this.next_generated_date = value?.next_generated_date
      this.showModal()
    },

    showModal() {
      this.$bvModal.show('modal-recurring-policy-assign-form')
    },

    hiddenModal() {
      this.$bvModal.hide('modal-recurring-policy-assign-form')
      this.resetModal()
    },

    resetModal() {
      this.next_generated_date = ''
    },

    async submit() {
      this.$refs.policyForm.validate().then(async success => {
        if (success) {
          this.isLoading = true
          try {
            const policyData = {
              next_generated_date: this.next_generated_date
            }

            await this.$api.put(`/api/recurring-policies/users/assign/${this.policyId}`, policyData)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'BellIcon',
                variant: 'success',
                text: 'Successfully Updated',
              },
            })

            this.loadItems() // Refresh item list
            this.hiddenModal() // Close the modal
            this.isLoading = false
          } catch (error) {
            this.isLoading = false
            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error',
                  icon: 'BellIcon',
                  variant: 'danger',
                  text: error?.response?.data?.message,
                },
              })
            }

            if (error?.response?.data?.errors) {
              this.$refs.addDelayFinePolicy.setErrors(error?.response?.data?.errors)
            }
          }
        }
      })
    },


    async getSetting(params) {
      return await this.$api.get("/api/settings", {
        params: {
          select: params.select,
        },
      });
    },
    async getCurrencies() {
      return await this.$api.get("/api/currencies/all");
    },
    handleUserAssignFromData(data) {
      this.policyAssignData = data;
    },

    hiddenPolicyAssignModal() {
      this.$bvModal.hide("modal-policy-assign-user");
    },
    showPolicyAssignModal(value) {
      this.$bvModal.show("modal-policy-assign-user");
    },

    formatDate(value)
    {
      if (value) {
        return this.$moment(value).format("MMM Do YYYY");
      }
      return "Not Set";
    },

    onSearch() {
      if (this.delayTimer) {
        clearTimeout(this.delayTimer);
        this.delayTimer = null;
      }

      this.delayTimer = setTimeout(() => {
        this.loadItems();
      }, 1000);
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    async getPolicyDetails() {
      const id = this.$route.params.id;
      return await this.$api.get(`/api/recurring-policies/${id}`);
    },
    async getAssignedUserDetails(params) {
      const policyCategoryId = this.$route.params.policyCategoryId;

      const id = this.$route.params.id;

      return await this.$api.get(
          `api/recurring-policies/users/assign/${id}?include=user`,
          {
            params: {
              show: params.show,
              page: params.page,
              sort: params.sort,
              q: params.q,
            },
          }
      );
    },
    async loadItems() {
      try {
        const [policyDetails, assignedUserDetails] = await Promise.all([
          this.getPolicyDetails(),
          this.getAssignedUserDetails({
            show: this.serverParams.perPage,
            page: this.serverParams.page,
            sort: this.serverParams.sort,
            q: this.searchTerm,
          }),
        ]);

        this.policyDetails = policyDetails?.data?.data;

        const meta = assignedUserDetails?.data?.meta;
        this.rows = assignedUserDetails?.data?.data;


        this.totalRecords = meta?.pagination?.total;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },

    assignUserPolicyForm: async function () {
      this.$refs.assignUserPolicy.validate().then(async (success) => {
        if (success) {

          const policyCategory = "Recurring Policy";
          this.$swal({
            title: "Warning!",
            text: `This users existing policy will be replaced by the new policy.`,
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Ok",
            showLoaderOnConfirm: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                this.$refs.assignUserPolicy.reset();

                this.isUserPolicyAssignFormSubmitLoading = true;

                const id = this.$route.params.id;

                await this.$api.post(`/api/recurring-policies/users/assign/${id}`, {
                  applied_to: this.policyAssignData?.appliedTo,
                  is_all_department_selected:
                  this.policyAssignData?.isAllDeptSelected,
                  is_all_user_selected:
                  this.policyAssignData?.isAllUserSelected,
                  department_ids: this.policyAssignData?.departmentIds,
                  except_user_ids: this.policyAssignData?.exceptUserIds,
                  user_ids: this.policyAssignData?.userIds,
                  start_date: this.start_date
                });

                this.isUserPolicyAssignFormSubmitLoading = false;
                this.hiddenPolicyAssignModal();
                this.loadItems();

                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: "Policy Assigned Successfully ",
                  },
                });
              } catch (error) {
                this.isUserPolicyAssignFormSubmitLoading = false;
                if (error?.response?.data?.message) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: error?.response?.data?.message,
                    },
                  });
                }

                if (error?.response?.data?.errors) {
                  this.$refs.assignUserPolicy.setErrors(
                      error?.response?.data?.errors
                  );
                }
              }
            } else {
              this.hiddenPolicyAssignModal();
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.flatpickr-wrapper{
  width: 100% !important;
}

.flatpickr-input[readonly]:disabled {
  color: #d3d3d3 !important; /* Custom color (light gray in this case) */
  background-color: transparent !important;
  cursor: not-allowed;
}
</style>
